module.exports = __webpack_public_path__ + "img/LocalFireDepartmentOutlined.b344bd28.svg";